export default __webpack_public_path__ + "static/media/(15).e2ce867d.jpg";